/**
 * Support only scroll and resize, no animation/transition or position changed by script
 * @param {Array.<HTMLElement>|NodeList} elements
 * @param {HTMLElement|Window} root
 * @constructor
 * @class ScrollAnimator
 */
function ScrollAnimator(root, elements){
	this._root = root;
	this._elements = elements;
	this._window = this._root instanceof Window ? this._root : this._root.ownerDocument.defaultView;
	this._animationFrameHandlerBound = this._animationFrameHandler.bind(this);
	this._scrollHandlerBound = this._scrollHandler.bind(this);
	this._resizeHandlerBound = this._resizeHandler.bind(this);

	// Listen local viewport scroll (document)
	this._root.addEventListener("scroll", this._scrollHandlerBound, true);
	// Listen viewport scroll (document's window)
	this._window.addEventListener("resize", this._resizeHandlerBound, true);

	this._setDirty();
}

ScrollAnimator.IN_VIEWPORT_CLASS = "element--in-viewport";

/** @type DocumentView */
ScrollAnimator.prototype._window = null;
/** @type {Node} */
ScrollAnimator.prototype._root = null;
/** @type {Array.<HTMLElement>\NodeList} */
ScrollAnimator.prototype._elements = null;
/** @type {Number} */
ScrollAnimator.prototype._animationFrameRequestID = 0;
ScrollAnimator.prototype._animationFrameHandlerBound = null;
ScrollAnimator.prototype._scrollHandlerBound = null;
ScrollAnimator.prototype._resizeHandlerBound = null;

ScrollAnimator.prototype._scrollHandler = function _scrollHandler(event){
	this._setDirty();
};

ScrollAnimator.prototype._resizeHandler = function _resizeHandler(event){
	this._setDirty();
};

ScrollAnimator.prototype._checkElements = function _checkElements(){
	var dirtyElements = [];
	var viewWidth = this._window.innerWidth;
	var viewHeight = this._window.innerHeight;
	// Optimize reflows, all in once
	// First get bounds
	for(var elementIndex = 0, numElements = this._elements.length; elementIndex < numElements; elementIndex++){
		var element = this._elements[elementIndex];

		// Use getBoundingClientRect() instead of offset[Left|Top] because SVG nodes don't have the last ones
		// Also it's take account of scroll positions (viewport and all others scrollable elements): no need offsetTop + scrollTop of each offsetParents
		// And CSS transforms too
		var bounds = element.getBoundingClientRect();
		var minimumVisibleX = Math.min(90, bounds.width)//in px
		var minimumVisibleY = Math.min(90, bounds.height)//in px
		if(
			// Visible in X axis (or before)
			bounds.left + minimumVisibleX < viewWidth// && bounds.right - minimumVisibleX > 0
			// visible in Y axis (or before)
			&& bounds.top + minimumVisibleY < viewHeight// && bounds.bottom - minimumVisibleY > 0
			&& !element.classList.contains(ScrollAnimator.IN_VIEWPORT_CLASS)){
			dirtyElements.push(element);
		}
	}

	// Second check if we need to start animation
	for(var dirtyElementIndex = 0, numDirtyElement = dirtyElements.length; dirtyElementIndex < numDirtyElement; dirtyElementIndex++) {
		var dirtyElement = dirtyElements[dirtyElementIndex];
		dirtyElement.classList.add(ScrollAnimator.IN_VIEWPORT_CLASS);
		//dirtyElement.style.animationPlayState = "running";
	}

};

ScrollAnimator.prototype._animationFrameHandler = function animationFrameHandler(){
	this._animationFrameRequestID = 0;
	this._checkElements();
};

ScrollAnimator.prototype._setDirty = function _setDirty(){
	// Requesting one animation frame if it's not already done
	if(this._animationFrameRequestID === 0) {
		this._animationFrameRequestID = requestAnimationFrame(this._animationFrameHandlerBound);
	}
};

ScrollAnimator.prototype.clear = function clear(){
	cancelAnimationFrame(this._animationFrameRequestID);
	this._root.removeEventListener("scroll", this._scrollHandlerBound, true);
	this._window.removeEventListener("resize", this._resizeHandlerBound, true);
};